"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.useUpdateEmail = void 0;
var use_flex2_api_1 = require("../use-flex2-api");
var v1_routes_1 = require("./v1-routes");
var useUpdateEmail = function () {
    var _a = (0, use_flex2_api_1.useFlex2API)({}, { manual: true }), _b = _a[0], data = _b.data, loading = _b.loading, error = _b.error, response = _b.response, execute = _a[1];
    return [
        { data: data, loading: loading, error: error, response: response },
        function (request) {
            var customer_public_id = request.customer_public_id, body = __rest(request, ["customer_public_id"]);
            return execute({
                url: (0, v1_routes_1.updateEmailRoute)(customer_public_id),
                method: 'POST',
                data: body
            });
        },
    ];
};
exports.useUpdateEmail = useUpdateEmail;
